import { useQuery } from '@tanstack/react-query';
import { fetchCurrentEmergencyState } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useFetchCurrentEmergencyState = () =>
  useQuery({
    queryFn: async () => extractData(fetchCurrentEmergencyState()),
    queryKey: ['emergencyMode', 'publisher-emergency-reports'],
    select(data) {
      if (!data) return {};

      data.publisherEmergencyReports?.sort((a, b) => {
        const statusDiff = (a.status ?? 0) - (b.status ?? 0);
        if (statusDiff !== 0) return statusDiff;
        return (a.publisher?.name ?? '').localeCompare(b.publisher?.name ?? '');
      });

      return data;
    },
    refetchInterval: 2000,
  });
